import { useState } from 'react';
import axios from 'axios';
import { Button, Form, Alert, Modal } from 'react-bootstrap';

const RecuperarContraseñaModal = ({ show, onClose }) => {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleEnviarCorreo = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post('/api/password/reset-link', { email });
      setEnviado(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al enviar enlace.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setEnviado(false);
    setError('');
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Recuperar Contraseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!enviado ? (
          <Form onSubmit={handleEnviarCorreo}>
            <Form.Group className="mb-3">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Button type="submit" className="w-100" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar enlace'}
            </Button>
          </Form>
        ) : (
          <Alert variant="success">
            Se ha enviado un enlace de recuperación a tu correo.
          </Alert>
        )}

        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
      </Modal.Body>
    </Modal>
  );
};

export default RecuperarContraseñaModal;
